export const styles = {
  chip: {
    minWidth: 100,
    borderRadius: 2,
  },
};
